import {
  PromotionEvaluation,
  SkippedPromotion
} from '../../../../types/promotion'

/**
 * Which refusal, if any, belongs to the code the booker entered.
 *
 * Pure and separate from the component because it is the subtlest logic here and was
 * otherwise reachable only through a full render. Returns undefined when the code APPLIED:
 * there is nothing to explain, and the caller shows the applied promotion instead.
 *
 * The three branches, in order:
 *
 *  1. The service's own mark. It resolved the code against a promotion in order to
 *     evaluate it, so it knows which entry is the booker's; nothing else does.
 *  2. A `Code`-prefixed reason. The mark is absent when the code matched nothing, when it
 *     was ambiguous across providers, or when the response came from an older service —
 *     `false` means "not known to be yours", not "not yours" — so dropping to the guess is
 *     a degradation rather than a failure.
 *  3. First skipped entry. Nothing orders this array, which is why branch 1 exists at all.
 *
 * The fallback mirrors the php orchestrator's on purpose, so a booker is not given one
 * explanation here and a different one through a partner integration.
 */
export function selectRefusal(
  result: PromotionEvaluation | undefined,
  codeApplied: boolean
): SkippedPromotion | undefined {
  if (codeApplied) {
    return undefined
  }

  return (
    result?.skipped.find((skip) => skip.matchedSuppliedCode) ??
    result?.skipped.find((skip) => skip.reason.startsWith('Code')) ??
    result?.skipped[0]
  )
}
